import React, { Children, cloneElement, isValidElement } from 'react'

const Stack = ({ children, spacing = 2, ...props }) => {
  const validChildrenArray = Children.toArray(children).filter(isValidElement)

  return (
    <div {...props}>
      {validChildrenArray.map((child, index) => {
        const isLastChild = validChildrenArray.length === index + 1
        const spacingProps = {
          style: {
            ...child.props.style,
            marginBottom: isLastChild ? null : spacing,
          },
        }

        return cloneElement(child, spacingProps)
      })}
    </div>
  )
}

export default Stack
